import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DashboardFrame } from '@eforall/dashboard';


@Component({
	selector: 'programs-frame',
	standalone: true,
	imports: [
		RouterOutlet,
		DashboardFrame,
	],
	templateUrl: './frame.page.html',
	styleUrls: ['./frame.page.scss']
})
export class FramePage {

}